import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import Error from '@components/Error/Error'
import PageHeading from '@components/PageHeading/PageHeading'
import Table from '@components/pages/PaymentPlan/DetailsTable'
import GET_PAYMENT_PLAN from '@graphql/queries/get-payment-plan'

function Details() {
  const { paymentPlanId } = useParams()
  const [fields, setFields] = useState([])
  const EXCLUDE_FROM_FIELDS = ['__typename', 'transactionId']
  const { data, loading, error } = useQuery(GET_PAYMENT_PLAN, {
    variables: { id: paymentPlanId },
    onCompleted: (data) => setFields(Object.keys(data.paymentPlan).filter((key) => !EXCLUDE_FROM_FIELDS.includes(key)))
  })

  return (
    <>
      <PageHeading heading='Payment Plan Details' />

      {error ? (
        <Error error={error} />
      ) : (
        <Table
          paymentPlan={data?.paymentPlan}
          fields={fields}
          loading={loading}
        />
      )}
    </>
  )
}

export default Details
